import Icon from '@material-ui/core/Icon';
import withStyles from '@material-ui/styles/withStyles';
var StyledIcon = withStyles({
    root: {
        margin: '0px 5px',
        cursor: 'pointer',
        color: '#676767',
    },
})(Icon);
export default StyledIcon;
//# sourceMappingURL=index.js.map